/*********************** Custom JS for Boost AI Search & Discovery  ************************/
function waitForElm(selector) {
    return new Promise(resolve => {
        if (document.querySelector(selector)) {
            return resolve(document.querySelector(selector));
        }

        const observer = new MutationObserver(mutations => {
            if (document.querySelector(selector)) {
                observer.disconnect();
                resolve(document.querySelector(selector));
            }
        });

        // If you get "parameter 1 is not of type 'Node'" error, see https://stackoverflow.com/a/77855838/492336
        observer.observe(document.body, {
            childList: true,
            subtree: true
        });
    });
}

// REMOVE PRICES FOR OUT OF STOCK ITEM
waitForElm('.boost-sd__product-list').then((elm) => {
  const outOfStockProduct = $('.boost-sd__product-label-text:contains("SOLD OUT")')
  outOfStockProduct.each(function () {
    const item = $(this).closest('.boost-sd__product-item')[0]
    const priceEl = $(item).find('.boost-sd__product-price')[0]
    $(priceEl).remove()
  })
})

// ADD SIZE TAGS TO PRODUCTS
waitForElm('.boost-sd__product-list').then((elm) => {
    const callback = function(mutationsList, observer) {
      for (const mutation of mutationsList) {
        if (mutation.type === 'childList') {
          addTag(elm.childNodes, '.boost-sd__product-link')
          addLikeButton(elm.childNodes)
        }
      }
    }

    const observer = new MutationObserver(callback)
    observer.observe(elm, { childList: true, subtree: false })
    addTag(elm.childNodes, '.boost-sd__product-link')
    addLikeButton(elm.childNodes)
})

const addLikeButton = async (childNodes) => {
  // Initial state check
  // verify token
  await new Promise(resolve => setTimeout(resolve, 250))
  const token = localStorage.getItem('accessToken')
  let likes = []

  if (token) {
    const headers = new Headers({ 'Authorization': 'Bearer ' + token })
    await fetch('https://production.api-silkorlace.com/profile/me', { headers, credentials: 'include' })
      .then(res => res.ok ? res.json() : null)
      .then(data => {
        console.log('--- data', data)
        if (!data) return
        likes = data.profile.likes
      })
      .catch(console.error)
  }
  
  childNodes.forEach((productEl) => {
    const productId = productEl.getAttribute('data-product-id')
    if (!productId || productEl.querySelector('.product-like-wrapper')) return

    const likeWrapper = document.createElement('div')
    likeWrapper.className = 'product-like-wrapper'
    likeWrapper.style.margin = '8px'
    likeWrapper.style.position = 'absolute'
    likeWrapper.style.right = '0'
    likeWrapper.style.top = '0'
    likeWrapper.style.display = 'inline-block'
    likeWrapper.style.zIndex = '1000'

    // create button and event
    const heartBtn = document.createElement('button')
    heartBtn.className = 'heart-button'
    heartBtn.onclick = () => {
      const token = localStorage.getItem('accessToken')
      if (!token) {
        const currentUrl = window.location.href
        window.location.href = `https://production.api-silkorlace.com/login?next=${encodeURIComponent(currentUrl)}`
        return
      }

      const isLiked = heartBtn.classList.contains('liked')
      const endpoint = isLiked ? 'unlike' : 'like'
      heartBtn.classList.toggle('liked', !isLiked)

      const headers = new Headers({ 'Authorization': 'Bearer ' + token })
      fetch(`https://production.api-silkorlace.com/${endpoint}/${productId}`, { headers, credentials: 'include' })
        .then(res => {
          if (res.status === 401) {
            window.location.href = `https://production.api-silkorlace.com/login?next=${encodeURIComponent(window.location.href)}`
          }
        })
        .catch(console.error)
    }

    // add liked styles
    const liked = likes.some(like => {
      return like.id === parseInt(productId)
    })
    if (liked) heartBtn.classList.add('liked')

    // attach to dom
    likeWrapper.appendChild(heartBtn)
    productEl.appendChild(likeWrapper)
  })
}

const tagReqObj = {}
const addTag = (childNodes, linkSelector) => {
  childNodes.forEach(async productEl => {
    const slug = productEl.querySelector(linkSelector).href.split('/products/')[1]
        
    if (slug) {
      let json = tagReqObj[slug]

      if (!json) {
        const resp = await fetch(`/products/${slug}.js`)
        json = await resp.json()
        tagReqObj[slug] = json
      }
      
      const sizeOption = json.options.find(option => option.name === "Size" || option.name === "size");
      const sizeValues = sizeOption ? sizeOption.values : [];
      const availabilityStatus = sizeValues.map(sizeValue => {
        const isAvailable = json.variants.some(variant => 
          variant.available && 
          (variant.option1 === sizeValue || variant.options.includes(sizeValue))
        );
      
        return { name: sizeValue, available: isAvailable };
      })

      if (productEl.querySelector('.tag-wrapper')) return

      if (availabilityStatus.length > 0) {
        const tagWrapper = document.createElement('div')
        tagWrapper.classList.add('tag-wrapper')
        productEl.querySelector('.boost-sd__product-title').appendChild(tagWrapper)
      }

      availabilityStatus.forEach((sizeObj) => {
        if (sizeObj.available) {
          // add tag to element
          const tagEl = document.createElement('span')
          tagEl.textContent = sizeObj.name.split(' -')[0]
          tagEl.classList.add('size-tag')
          productEl.querySelector('.tag-wrapper').appendChild(tagEl)
        }
      })
    }
  })
}

// ADD HERO IMAGE TO COLLECTION
if (window.location.href.includes("https://silkorlace.com/collections/slc-closed-lace-hair-toppers")) {
  const page = document.querySelector('.shopify-section .section .container')
  const banner = document.createElement('div')
  const title = document.createElement('h1')
  const textEl = document.createElement('div')
  
  title.innerHTML  = 'SILK OR LACE COLLECTION<br>CLOSED LACE TOPPER'
  textEl.innerHTML = ` <h2>Our Lowest Profile for An Easy Blend for Beginners</h2>
    • Blend like a pro with a rim as thick as a sheet of paper<br>
    • Low density for realistic, natural look`

  banner.classList.add('collection-banner')
  textEl.classList.add('banner-text')

  banner.append(title)
  banner.append(textEl)
  page.prepend(banner)
}

if (window.location.href.includes("https://silkorlace.com/collections/slc-hd-lace-wigs")) {
  const page = document.querySelector('.shopify-section .section .container')
  const banner = document.createElement('div')
  const title = document.createElement('h1')
  const textEl = document.createElement('div')
  
  title.innerHTML  = 'SILK OR LACE COLLECTION<br>GLUELESS CAP WIG'
  textEl.innerHTML = `<h2>Undetectable wear</h2>
    • Transparent HD Lace<br>
    • Detailed, bleached knots for a natural looking hairline<br>
    • Fine textured hair mimicking those with thin hair and hair loss`

  banner.classList.add('collection-banner')
  textEl.classList.add('banner-text')

  banner.append(title)
  banner.append(textEl)
  page.prepend(banner)
}

// Add tags to search
const searchReqObj = {}

waitForElm('.boost-sd__instant-search-results').then((elm) => {
  document.querySelectorAll('.boost-sd__instant-search-results').forEach(results => {
    const callback = function(mutationsList, observer) {
      for (const mutation of mutationsList) {
        if (mutation.type === 'childList') {
          results.querySelectorAll('.boost-sd__suggestion-queries-item').forEach(async productEl => {
            const slug = productEl.querySelector('.boost-sd__suggestion-queries-item-link').href.split('/products/')[1]

            if (slug) {
              let json = searchReqObj[slug]

              if (!json) {
                const resp = await fetch(`/products/${slug}.js`)
                json = await resp.json()
                searchReqObj[slug] = json
              }
              
              const sizeOption = json.options.find(option => option.name === "Size" || option.name === "size");
              const sizeValues = sizeOption ? sizeOption.values : [];
              const availabilityStatus = sizeValues.map(sizeValue => {
                const isAvailable = json.variants.some(variant => 
                  variant.available && 
                  (variant.option1 === sizeValue || variant.options.includes(sizeValue))
                );
              
                return { name: sizeValue, available: isAvailable };
              })

              if (productEl.querySelector('.tag-wrapper')) return
        
              if (availabilityStatus.length > 0) {
                const tagWrapper = document.createElement('div')
                tagWrapper.classList.add('tag-wrapper')
                productEl.querySelector('.boost-sd__suggestion-queries-item-title').appendChild(tagWrapper)
              }
        
              availabilityStatus.forEach((sizeObj) => {
                if (sizeObj.available) {
                  // add tag to element
                  const tagEl = document.createElement('span')
                  tagEl.textContent = sizeObj.name.split(' -')[0]
                  tagEl.classList.add('size-tag')
                  tagEl.classList.add('small-tag')
                  productEl.querySelector('.tag-wrapper').appendChild(tagEl)
                }
              })
            }
          })
        }
      }
    }
    const observer = new MutationObserver(callback)
    observer.observe(results, { childList: true, subtree: false })
  })
})
